import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import DataDrivenLogo from '../../../data-driven-logo';

import style from './orders-header.module.less';

const messages = defineMessages({
  ordersCount: {
    description: 'orderDrawer.orders.orderPlural',
    defaultMessage: '{ordersCount, plural, one {# Row} other {# Rows}} Selected',
    id: 'l/NoBA',
  },
});

const renderOrderNumberWithUrl = (externalUrl, orderNumbers) => {
  if (externalUrl) {
    return (
      <a href={externalUrl} rel='noopener noreferrer' target='_blank'>
        {orderNumbers}
      </a>
    );
  }
  return <React.Fragment>{orderNumbers}</React.Fragment>;
};

const OrdersHeader = ({ ordersCount = 0, marketplaceId, orderNumbers, externalUrl = '', isSilentlyLoading = false }) => {
  return (
    <div className={style['header-container']}>
      {marketplaceId && (
        <DataDrivenLogo className={style['third-party-logo']} logoType='icon' marketplaceId={Number.parseInt(marketplaceId, 10)} />
      )}
      <b className={style['order-number-part']}>
        {orderNumbers && renderOrderNumberWithUrl(externalUrl, orderNumbers)}
        {!orderNumbers && <FormattedMessage {...messages.ordersCount} values={{ ordersCount }} />}
      </b>
      {isSilentlyLoading && (
        <div className={style['loading-indicator-wrap']}>
          <LoadingIndicator className={style['loading-indicator']} />
          <FormattedMessage defaultMessage='loading' description='ordersHeader.loading' id='h7KX7Z' />
        </div>
      )}
    </div>
  );
};

OrdersHeader.propTypes = {
  ordersCount: PropTypes.number,
  marketplaceId: PropTypes.string,
  orderNumbers: PropTypes.string,
  externalUrl: PropTypes.string,
  isSilentlyLoading: PropTypes.bool,
};

export default OrdersHeader;
